<ul class="app-checkboxset list-group tab-order">
  <li  *ngFor=" let widgetData of activeWidget.tabs;" ng-init="showHideActions()" [ngClass]="{activetabwidget: widgetData.name === activeWidget.activeTab?.name}" class="list-group-item form-control" >
    <label class="app-checkboxset-label">
      <span >{{widgetData?.title}}</span>
      </label>
    </li>
  </ul>
<button style="visibility: hidden" (click)="moveTab(-1)" class="btn-transparent arrowUp"><i class="wms wms-keyboard-arrow-up"></i></button>
<button (click)="moveTab(1)" class="btn-transparent arrowDown"><i class="wms wms-keyboard-arrow-down"></i></button>
